import { useContext } from "react";
import ContentSection from "./ContentSection";
import FormattingSection from "./FormattingSection";
import GrammarSection from "./GrammarSection";
import "./index.css";
import UserLetter from "./UserLetter";
import { AppContext } from "../../../../../Util/contexts/AppContext";
import formatDateString from "../../../../../Util/functions/FormatDateString";
import formatTimeString from "../../../../../Util/functions/FormatTimeString";
import { wasMoreThanXMinutesAgo } from "../../../../../Util/functions/Timing";
import { getClientTimezoneName } from "../../../../../Util/functions/TimeZone";
import { useState, useEffect } from "react";
const WritingGradeSection = ({
  writingGrade,
  lastChecked,
  resendCaseGrade,
  sectionId,
  resendingGrade,
}) => {
  const { userData } = useContext(AppContext);
  const sentToAITime = new Date(writingGrade.SentToAITime);
  const hasFeedback =
    writingGrade.Feedback &&
    writingGrade.Feedback.format &&
    Object.keys(writingGrade.Feedback.format).length > 0;
  const isInProcess = writingGrade.state === "in_process";

  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    if (writingGrade.state === "processing") {
      const interval = setInterval(() => {
        setCurrentTime(Date.now());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [writingGrade.state]);

  const secondsSinceLastCheck = Math.floor(
    (Date.now() - new Date(lastChecked).getTime()) / 1000
  );
  console.log("Grade", writingGrade);
  const showResendButton =
    !sentToAITime || wasMoreThanXMinutesAgo(sentToAITime, 20);

  if (writingGrade.state === "processing") {
    return (
      <div className="gradingFeedbackSectionBodyContainer writingGradeErrorWrapper">
        <div className="gradingFeedbackWaitingForGradeContainer">
          <h2 className="gradingFeedbackWaitingForGradeTitle">
            Grading In Progress
          </h2>
          <p className="gradingFeedbackWaitingForGradeText">
            This section was sent for grading on{" "}
            {formatDateString(
              writingGrade.SentToAITime,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}{" "}
            at{" "}
            {formatTimeString(
              writingGrade.SentToAITime,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}
            . Writing exams can take 5 or more minutes to be graded. We will
            check for your grade every 20 seconds. This section will populate
            once your exam is graded, or you can check back later.
          </p>
          <p className="gradingFeedbackWaitingForGradeSubtext">
            Last checked for grade {secondsSinceLastCheck} seconds ago
            <br></br>
            <br></br>
          </p>
          {showResendButton && !resendingGrade && (
            <div>
              <p className="gradingFeedbackWaitingForGradeText">
                Something went wrong <br></br>
                Click below to resend to grade.
              </p>
              <button
                className="tertiaryButton newGradingButton"
                onClick={async () => {
                  await resendCaseGrade("writing", sectionId);
                }}
              >
                Resend
              </button>
            </div>
          )}
          {resendingGrade && (
            <p className="gradingFeedbackWaitingForGradeText">
              Resending grade...
            </p>
          )}
        </div>
      </div>
    );
  } else if (isInProcess || !hasFeedback) {
    return (
      <div className="gradingFeedbackSectionBodyContainer writingGradeErrorWrapper">
        <div className="gradingFeedbackWaitingForGradeContainer">
          This grade is corrupt and unavailable.{" "}
          {isInProcess
            ? "Grade is marked as in process. This is an error. Please check back soon or contact us about this grade."
            : "Grade exists but contains no data. Please refresh your application. If this does not work, please contact us about this grade."}
        </div>
      </div>
    );
  }

  const gradeDetails = writingGrade.Feedback.format;
  const grammar = gradeDetails["Section #1: Grammar / Spelling"];
  const formatting = gradeDetails["Section #2: Formatting"];
  const content = gradeDetails["Section #3: Content"];
  console.log("Grade details", gradeDetails);

  return (
    <>
      <div className="gradingFeedbackSectionBodyContainer writingGradeSectionWrapper">
        <UserLetter
          letterInput={writingGrade.userWritingInput}
          grammar={grammar}
        />
        <GrammarSection grammar={grammar} />
        <FormattingSection formatting={formatting} />
        <ContentSection content={content} />
      </div>
    </>
  );
};

export default WritingGradeSection;
